module.exports = __webpack_public_path__ + "static/media/dcs013.317a36cb.png";